import React, { useEffect, useContext, useState } from 'react';
import { EntitiesContext } from '../../../App';
import { useCreateInventory } from '../../../hooks/useInventory';
import InventoryRecord from '../../../records/inventory';
import UserRecord from '../../../records/user';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollar} from '@fortawesome/free-solid-svg-icons';

const dollarIcon = <FontAwesomeIcon icon={faDollar} />

export default function Custom({ vendorId, setVendorId }) {
  const entities = useContext(EntitiesContext);
  const [vendor, setVendor] = useState(null);
  const [amount, setAmount] = useState('');

  const createInventory = useCreateInventory();

  useEffect(() => {
    if (vendorId && !vendor?.id || vendor?.id !== vendorId) {
      setVendor(entities.state.get('account').get(vendorId));
    }
  }, [vendorId]);

  useEffect(() => {
    if (vendor && vendor.vendor_name.toLowerCase() === 'ikea bag' && amount === '') {
      setAmount(5);
    }
  }, [vendor]);

  const add = () => {
    createInventory.mutate(new InventoryRecord({
      account_id: vendor.id,
      name: `${vendor.vendor_name} item`,
      price: parseInt(amount)
    }));

    setVendor(null);
    setVendorId(null);
    setAmount('');
  }

  const cancel = () => {
    setVendor(null);
    setVendorId(null);
    setAmount('');
  }

  if (!vendor || !vendor.id) return <></>;

  return (
    <div className="container">
      Enter Amount for: <span className="has-text-weight-semibold">{vendor.vendor_name}</span>

      <div className="field">
        <div className="control has-icons-left">
          <input className="input is-large" type="number" name="amount" onChange={e => setAmount(e.target.value)} value={amount} />
          <span className="icon is-large is-left">
            {dollarIcon}
          </span>
        </div>
      </div>

      <div className="level is-mobile">
        <div className="level-item">
          <button className="button is-fullwidth" onClick={cancel}>Cancel</button>
        </div>
        <div className="level-item">
          <button className="button is-link is-fullwidth" onClick={add} disabled={createInventory.isLoading}>Add to Order</button>
        </div>
      </div>
    </div>
  )
}
